import React from 'react';
import { useViewMode } from '@/context/ViewModeContext';
import { GameplaySectionShell, type GameplaySectionProps } from './GameplaySectionShell';

const GameplaySection: React.FC<GameplaySectionProps> = (props) => {
  const { isIframeView } = useViewMode();

  return <GameplaySectionShell {...props} isIframeView={isIframeView} />;
};

export default GameplaySection;
